import Header from "./Header";
import React, {Fragment, useState} from "react";
import Loading from "../Loading";
import {Route, Switch} from "react-router-dom";

import Home from "./Home";
import Trades from "./Trades";
import Markets from "./Markets";
import Login from "./Login";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import Dashboard from "./profile/dashboard";
import Charge from "./profile/charge";
import Payments from "./profile/payments";
import Sells from "./profile/sells";
import Transactions from "./profile/transactions";
import Footer from "./Footer";

const Index = (props) => {

    const [d, setD] = useState(false);
    const [trade, setTraid] = useState('');

    return (
        <div className={"d-flex flex-column min-h-screen"}>
            <Header ctx={props.ctx} profile={props.profileprofile} auth={props.auth} setAuth={props.setAuth} trade={trade} setTraid={setTraid} d={d} setD={setD}
                    logo={props.logo} trs={props.trs}/>

            <React.Suspense fallback={<Loading/>}>
                <Switch>
                    {props.auth !== null &&
                        <Route   path={window.config.staticAddress + "/profile/dashboard"}>

                            <Dashboard  ctx={props.ctx} profile={props.profile}  auth={props.auth} ajax={props.ajax} setAuth={props.setAuth} logo={props.logo}
                                       trs={props.trs}/>
                        </Route>}

                    {props.auth !== null &&
                        <Route   path={window.config.staticAddress + "/profile/charge/:slug"}>

                            <Charge  ctx={props.ctx} profile={props.profile}  auth={props.auth} ajax={props.ajax} setAuth={props.setAuth} logo={props.logo}
                                       trs={props.trs}/>
                        </Route>}

                    {props.auth !== null &&
                        <Route   path={window.config.staticAddress + "/profile/payments"}>

                            <Payments  ctx={props.ctx} profile={props.profile}  auth={props.auth} ajax={props.ajax} setAuth={props.setAuth} logo={props.logo}
                                     trs={props.trs}/>
                        </Route>}
                    {props.auth !== null &&
                        <Route   path={window.config.staticAddress + "/profile/sells"}>

                            <Sells  ctx={props.ctx} profile={props.profile}  auth={props.auth} ajax={props.ajax} setAuth={props.setAuth} logo={props.logo}
                                     trs={props.trs}/>
                        </Route>}
                    {props.auth !== null &&
                        <Route   path={window.config.staticAddress + "/profile/Transactions"}>

                            <Transactions  ctx={props.ctx} profile={props.profile}  auth={props.auth} ajax={props.ajax} setAuth={props.setAuth} logo={props.logo}
                                     trs={props.trs}/>
                        </Route>}
                    {props.auth !== null && <Route path={window.config.staticAddress + "/profile"}>

                        <Dashboard  ctx={props.ctx} profile={props.profile}  auth={props.auth} ajax={props.ajax} setAuth={props.setAuth} logo={props.logo}
                                   trs={props.trs}/>
                    </Route>}


                    {props.auth === null &&
                        <Route path={window.config.staticAddress + "/auth/login"}>

                            <Login  ctx={props.ctx} auth={props.auth} ajax={props.ajax} setAuth={props.setAuth} logo={props.logo}
                                   trs={props.trs}/>
                        </Route>}
                    {props.auth === null && <Route path={window.config.staticAddress + "/auth/register"}>
                        <Register  ctx={props.ctx} auth={props.auth} ajax={props.ajax} setAuth={props.setAuth} logo={props.logo}
                                  trs={props.trs}/>
                    </Route>}
                    {props.auth === null && <Route path={window.config.staticAddress + "/auth/forgotPassword"}>
                        <ForgotPassword  ctx={props.ctx} auth={props.auth} ajax={props.ajax} setAuth={props.setAuth} logo={props.logo}
                                        trs={props.trs}/>
                    </Route>
                    }

                    <Route path={window.config.staticAddress + "/trades/:slug"}>

                        <Trades  ctx={props.ctx} profile={props.profile}  trade={trade} addCommos={props.addCommos} removeCommos={props.removeCommos}
                                setTraid={setTraid} logo={props.logo} trs={props.trs}/>
                    </Route>
                    <Route path={window.config.staticAddress + "/markets"}>
                        <Markets  ctx={props.ctx} profile={props.profile}  logo={props.logo} trade={trade} setTraid={setTraid} trs={props.trs}/>
                    </Route>


                    <Route path="/*">
                        <Home  ctx={props.ctx} profile={props.profile}  trade={trade} setTraid={setTraid} btc={props.btc} logo={props.logo} trs={props.trs}/>
                    </Route>
                </Switch>
            </React.Suspense>


            <Footer  profile={props.profile}   ctx={props.ctx} auth={props.auth} setAuth={props.setAuth} trade={trade} setTraid={setTraid} logo={props.logo}
                    trs={props.trs}/>
        </div>
    )
}
export default Index;
